import React, { Component } from 'react'
import styled from 'styled-components'
import { Popconfirm, Button } from 'antd'
import history from '../../history'
import moment from 'moment'

const MarginTop = styled.div`
  margin-top: 15px;
`

class ContractTemplatePreview extends Component {
  printWorkByOthers = () => {
    return { __html: this.props.workByOthers.toString('html') }
  }

  printTerms = () => {
    return { __html: this.props.terms.toString('html') }
  }

  printPaymentScheduleLine = (paymentSchedule, index) => {
    const percentage = +paymentSchedule.percentage * 100
    return (
      <tr key={index}>
        <th scope="row">{percentage.toPrecision(2)}%</th>
        <td>{paymentSchedule.description}</td>
      </tr>
    )
  }

  render() {
    const { paymentScheduleDataStructure } = this.props
    return (
      <MarginTop>
        <h4>DETAILS</h4>
        <div className="row">
          <div className="col-4">
            <strong>Name</strong>
          </div>
          <div className="col-4">
            <strong>Created Date</strong>
          </div>
          <div className="col-4">
            <strong>Updated Date</strong>
          </div>
        </div>
        <div className="row">
          <div className="col-4">{this.props.templateName}</div>
          <div className="col-4">{moment(this.props.created_date).format('M/D/YYYY')}</div>
          <div className="col-4">{moment(this.props.updated_date).format('M/D/YYYY')}</div>
        </div>
        <div className="row mt-2">
          <div className="col-4">
            <strong>Description</strong>
          </div>
          <div className="col-4">
            <strong>Created By</strong>
          </div>
          <div className="col-4">
            <strong>Updated By</strong>
          </div>
        </div>
        <div className="row">
          <div className="col-4">{this.props.templateDescription}</div>
          <div className="col-4">{`${this.props.created_by_first_name} ${
            this.props.created_by_last_name
          }`}</div>
          <div className="col-4">{`${this.props.updated_by_first_name} ${
            this.props.updated_by_last_name
          }`}</div>
        </div>
        <MarginTop>
          <h4>WORK BY OTHERS</h4>
          <div className="row">
            <div className="col-12" dangerouslySetInnerHTML={this.printWorkByOthers()} />
          </div>
          <h4>TERMS</h4>
          <div className="row">
            <div className="col-12" dangerouslySetInnerHTML={this.printTerms()} />
          </div>
          {paymentScheduleDataStructure &&
            paymentScheduleDataStructure.length > 0 && (
              <div>
                <h4>PAYMENT SCHEDULE</h4>
                <div className="row">
                  <div className="col-12">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Percentage</th>
                          <th scope="col">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentScheduleDataStructure.map(this.printPaymentScheduleLine)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.confirmDelete}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon="delete" className="mr-2">
              Delete
            </Button>
          </Popconfirm>
        </MarginTop>
      </MarginTop>
    )
  }
}

export default ContractTemplatePreview



// WEBPACK FOOTER //
// ./src/components/templates/ContractTemplatePreview.js